import React from 'react';

const PageLayoutPanel = ({
  sheetsPerSignature,
  setSheetsPerSignature,
  fillLastSignature,
  setFillLastSignature,
  startPadding,
  setStartPadding,
  endPadding,
  setEndPadding
}) => {
  return (
    <div className="panel-content">
      <div className="input-group">
        <label>
          Sheets per signature:
          <input
            type="number"
            min="1"
            max="20"
            value={sheetsPerSignature}
            onChange={(e) => setSheetsPerSignature(parseInt(e.target.value))}
          />
        </label>
      </div>

      <div className="input-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={fillLastSignature}
            onChange={(e) => setFillLastSignature(e.target.checked)}
          />
          Fill last signature with blank pages
        </label>
      </div>

      <div className="input-group">
        <label>
          Start padding (blank pages):
          <input
            type="number"
            min="0"
            value={startPadding}
            onChange={(e) => setStartPadding(parseInt(e.target.value))}
          />
        </label>
      </div>

      <div className="input-group">
        <label>
          End padding (blank pages):
          <input
            type="number"
            min="0"
            value={endPadding}
            onChange={(e) => setEndPadding(parseInt(e.target.value))}
          />
        </label>
      </div>
    </div>
  );
};

export default PageLayoutPanel; 